import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge has to know our theme's names, or it cannot tell that
// `text-label` (a size) and `text-muted-foreground` (a colour) do not
// override each other, and silently drops one of them.
const merge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["title", "heading", "section", "number", "body", "detail", "label"],
      radius: ["card", "inner", "control", "tag", "flag", "pill"],
      shadow: ["emc", "card", "raised", "pop", "thumb", "button"],
      tracking: ["label", "title", "section"],
      "font-weight": ["title"],
      spacing: ["control", "control-sm", "sidebar", "panel"],
      container: ["content", "narrow", "panel", "tile"],
    },
  },
});

/** Join class names, the later one winning where two set the same thing. */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}

/**
 * A database id from the address bar, or null.
 *
 * At most 15 digits: past 2^53 `Number()` rounds, and a mistyped long id would
 * silently open a DIFFERENT record. The API refuses ids past bigint itself;
 * this keeps the browser from ever asking for the wrong one.
 */
export function routeId(raw: string | undefined): number | null {
  if (raw === undefined || !/^[1-9]\d{0,14}$/.test(raw)) return null;
  return Number(raw);
}
